import { createAsyncThunk } from '@reduxjs/toolkit';
import departmentService from './Department.service';
import { DepartmentFetchParams } from './Department.type';

export const getDepartmentListThunk = createAsyncThunk(
  'department/getDepartmentListThunk',
  async (params: DepartmentFetchParams, thunkAPI) => {
    const response = await departmentService.getList(params);
    return response.data;
  },
);
